export enum SelectSize {
  S = 's',
  M = 'm',
  L = 'l',
  XL = 'xl',
}
